import { Component, OnInit, Input } from '@angular/core';
import { SugestaoService } from 'src/app/service/sugestao/sugestao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'servicos-acoes-adm-sugestao',
  templateUrl: './servicos-acoes-adm-sugestao.component.html',
  styleUrls: ['./servicos-acoes-adm-sugestao.component.css']
})
export class ServicosAcoesAdmSugestaoComponent implements OnInit {

  @Input() visualizacao: boolean;
  listaClassificacaoComponente = [];
  charNum = 5000;

  constructor(
    public service: SugestaoService,
    private desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) { }

  ngOnInit() {
    this.preencherListaClassificacao();
  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.sugestao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.sugestao.value.assunto.id);
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.sugestao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.sugestao.controls[str].touched &&
      this.service.sugestao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

}
